import { useTranslation } from 'react-i18next';

import Alert from '../../../../../../components/Alert';
import RadioGroup from '../../../../../../components/FormControls/RadioGroup';
import RadioOption from '../../../../../../components/FormControls/RadioGroup/RadioOption';
import { ActivityDuration } from '../../../../../../db/types';
import { i18nNS } from '../../../../../../i18n';
import useDurationDialogVM, { Props as VMProps } from './vm';

interface Props extends VMProps {
  open: boolean;
  value: ActivityDuration;
  options: { label: string; value: ActivityDuration }[];
}

const DurationDialog = ({ open, value, options, ...vmOptions }: Props) => {
  const { t } = useTranslation([i18nNS.POLL, i18nNS.GLOSSARY, i18nNS.COMMON]);

  const { onClose: handleClose } = vmOptions;
  const { onSelectionChange } = useDurationDialogVM(vmOptions);

  const handleSelectionChange = (activityDuration: ActivityDuration) => () => {
    onSelectionChange(activityDuration);
  };

  return (
    <Alert open={open} onClose={handleClose} maxWidth="xs">
      <Alert.Header>{t('poll_closes', { ns: i18nNS.POLL })}</Alert.Header>
      <Alert.Body>
        <RadioGroup value={`${value}`}>
          {options.map((option) => (
            <div key={option.value} role="button" onClick={handleSelectionChange(option.value)}>
              <RadioOption
                value={`${option.value}`}
                aria-label={t('click_to_close_poll_time', {
                  ns: i18nNS.POLL,
                  endTime: option.label,
                })}
              >
                {option.label}
              </RadioOption>
            </div>
          ))}
        </RadioGroup>
      </Alert.Body>
      <Alert.Footer>
        <Alert.Action variant="text" aria-label={t('click_to_close_dialog', { ns: i18nNS.COMMON })}>
          {t('close', { ns: i18nNS.GLOSSARY })}
        </Alert.Action>
      </Alert.Footer>
    </Alert>
  );
};

export default DurationDialog;
